// extracted by mini-css-extract-plugin
module.exports = {"link":"_2gl9l","GamingButton":"_1aegb","gamingButton":"_1aegb","label":"QDBPm","left":"_1UP5B","right":"JSx-c","gradient":"r7BGu"};